import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";

import { useTranslation } from "react-i18next";
import { useForm, Controller } from 'react-hook-form';

const StepOne = ({ control, handleChange, contact, setContact }) => {
  // ----------- hooks ------------
  const { t,i18n } = useTranslation();
  const reasons_value = 
    [
      { label: "Real Estate Services", value: "Real Estate Services" },
      { label: "Company", value: "Company" },
      {
        label: "Events Organization",
        value: "Events Organization",
      },
      { label: "Logistics Services", value: "Logistics Services" },
      { label: "Catering Services", value: "Catering Services" },
      { label: "Food Services", value: "Food Services" },
      { label: "Employment", value: "Employment" },
      {
        label: "For Complaints and Inquiries",
        value: "For Complaints and Inquiries",
      },
    ];

  return (
    <div style={{direction: i18n.language === 'ar' ? 'rtl': 'ltr'}}>
      <h3 className="text-xl text-purple">{t("First Step")}</h3>
      <h1 className="text-2xl font-semibold pb-5">{t("Basic Information")}</h1>
      <p className="text-xl pb-5">
        {t("What is the purpose of communication?")}
        <span className="text-red-600">*</span>
      </p>
      <Controller
        name="contact_reason"
        control={control}
        defaultValue={""}
                rules={{
          required: 'First Name is required',
        }}
        render={({ field }) => (
        
         <select    {...field} className="inline-flex justify-between rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 border border-gray rounded-md w-48  hover:bg-gray-50">
          {reasons_value.map((item, index) => (

          <option className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          key={index} value={item.value}> {t(item.label) || '--'}</option>
          ))}
       
        </select>
        )}
      />
      <p className="text-xl py-5">
        {t("Are you an individual or a company?")}
        <span className="text-red-600">*</span>
      </p>
      <div className="flex flex-row justify-between">
        <div className="flex flex-row gap-2">
          <Controller
            name="type"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <>
                <input
                  type="radio"
                  name="type"
                  id="individual"
                  value="individual"
                  checked={field.value === "individual"}
                  onChange={() => field.onChange("individual")}
                />
                <label htmlFor="individual">{t("Individual")}</label>
              </>
            )}
          />
        </div>
        <div className="flex flex-row gap-2">
          <Controller
            name="type"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <>
                <input
                  type="radio"
                  name="type"
                  id="company"
                  value="company"
                  checked={field.value === "company"}
                  onChange={() => field.onChange("company")}
                />
                <label htmlFor="company">{t("Company")}</label>
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default StepOne;

            /*     values={} */